module.exports = __webpack_public_path__ + "static/media/icon.679c91d2.svg";